/* globals $ */

import { ajax } from "jquery";
import { getExtrasInput } from "./quoteboost";
import { setCookie } from "./common";
import { getCookie } from "./common";
import * as Sentry from '@sentry/browser';

// Format DOB input with slashes
let format = "dd/mm/yyyy";
let match = new RegExp(format
    .replace(/(\w+)\W(\w+)\W(\w+)/, "^\\s*($1)\\W*($2)?\\W*($3)?([0-9]*).*")
    .replace(/m|d|y/g, "\\d"));
let replace = "$1/$2/$3$4"
    .replace(/\//g, format.match(/\W/));


export function roundLoanAmount(amount) {
    var la = $('[name=loan_amount]');
    var previousVal = la.val();
    if (la.val() == '' && la.data('prev-val') != '' && typeof la.data('prev-val') !== 'undefined') {
        previousVal = la.data('prev-val');
        return previousVal;
    }
    var returnValue = Math.max(300, Math.min(5000, Math.ceil(amount / 50) * 50));
    la.data('prev-val', returnValue);
    return returnValue;
}

export function dobFormat(target) {
    target.value = target.value
        .replace(/(^|\W)(?=\d\W)/g, "$10") // padding
        .replace(match, replace) // fields
        .replace(/(\W)+/g, "$1"); // remove repeats
}

// Prevent letters in DOB input
export function dobNumeric(e) {
    // Allow: backspace, delete, tab, escape, enter and .
    if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
        // Allow: Ctrl+A, Command+A
        (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: home, end, left, right, down, up
        (e.keyCode >= 35 && e.keyCode <= 40)) {
        // let it happen, don't do anything
        return;
    }
    // Ensure that it is a number and stop the keypress
    if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault();
    }
}

export function sendSentryBreadcrumb(data) {
    if (typeof Raven !== 'undefined') {
        Raven.captureBreadcrumb(data);
    }
}

export function sendSentryMessage(text) {
    if (typeof Raven !== 'undefined') {
        Raven.captureException(new Error(text));
    }
}

export function showRedirectPage() {
    $('#progress-bar-circle-tick').fadeIn(800);
    $('.progressbar-text').addClass('progressbar-text-hidden');
    $('.exit-searching .header-text').html('We’ve found a loan that suits<br/> your needs!');
    $('.exit-searching .end-paragraph').text('You will now be redirected to the best suited loan for you.');
}

Date.prototype.addDays = function(days) {
    var dat = new Date(this.valueOf());
    dat.setDate(dat.getDate() + days);
    return dat;
};

export function fillAddressFields(data, form, suffix) {
    data = data.replace('false', ''); // Strip unwanted data from response
    var obj = JSON.parse(data);
    if (typeof suffix == 'undefined') {
        suffix = '';
        var currentAddressText = obj.house + ', ' + obj.street + ', ' + obj.town + ', ' + obj.county + ', ' + obj.postcode;
        $(".current-address-text").val(currentAddressText);
    } else {
        $('.need_address_2').addClass('hidden');
        $('.need_address_2').css('display', 'none');
    }
    otfValidate($("[name=house" + suffix + "]", form).val(obj.house));
    otfValidate($("[name=address1" + suffix + "]", form).val(obj.street));
    otfValidate($("[name=address2" + suffix + "]", form).val(obj.area));
    otfValidate($("[name=town" + suffix + "]", form).val(obj.town));
    otfValidate($("[name=postcode" + suffix + "]", form).val(obj.postcode));
    if (obj.town && obj.town === 'London' && obj.county == '') {
        obj.county = 'Greater London';
    }
    if (obj.town && obj.town === 'Manchester' && obj.county == '') {
        obj.county = 'Greater Manchester';
    }
    if (obj.town && obj.town === 'Edinburgh' && obj.county == '') {
        obj.county = 'Lothian Region';
    }
    if ($("[name=county" + suffix + "]", form).find('option[value="' + obj.county + '"]').length == 1) {
        $("[name=county" + suffix + "]", form).val(obj.county);
    } else {
        var lcCounty = obj.county + suffix.toLowerCase();
        var valueToPick = '';
        $("[name=county" + suffix + "]", form).find('option').each(function(i, o) {
            var $o = $(o);
            var thisVal = $o.val().toLowerCase();
            if (thisVal === lcCounty) {
                valueToPick = $o.val();
                return false;
            }
        });
        if (valueToPick === '') {
            // Add the option and just allow it through
            $("[name=county" + suffix + "]", form).append('<option value="' + obj.county + '">' + obj.county + '</option>');
            $("[name=county" + suffix + "]", form).val(obj.county);
        } else {
            $("[name=county" + suffix + "]", form).val(valueToPick);
        }
    }
    $("[name=postcode" + suffix + "]", form).val(obj.postcode);
    // $('.address-fields' + suffix, form).removeClass('hidden');
    setTimeout(function() {
        $('.address-fields' + suffix, form).addClass('in');
    }, 500);
    // $(".find-address",form).hide();
    $(".form-group.addressSelect" + suffix, form).addClass('hidden');
    $('[name=house' + suffix + ']', form).trigger('keyup');
    $('[name=address1' + suffix + ']', form).trigger('keyup');
    $('[name=address2' + suffix + ']', form).trigger('keyup');
    $('[name=town' + suffix + ']', form).trigger('keyup');
    $('[name=county' + suffix + ']', form).trigger('change');
    if ($('[name=address2' + suffix + ']', form).val() != '') {
        $('.address2' + suffix + '-form-group', form).removeClass('hidden');
    } else {
        $('.address2' + suffix + '-form-group', form).addClass('hidden');
    }
    if ($('[name=house' + suffix + ']', form).val() != '') {
        $('[name=house' + suffix + ']', form).addClass('otf-pass');
    }

    if ($('body').is('.with-address-summary')) {
        var postCodeFormGroup = $('.postcode' + suffix + '-form-group', form);
        var addressSummaryFormGroup = $('.address_summary' + suffix + '-form-group', form);
        var addressSummary = $('.address-summary' + suffix , form);
        var address2 = $('[name=address2' + suffix + ']', form);
        var address2FormGroup = $('.address2' + suffix + '-form-group', form);
        var addressFields = $('.address-fields' + suffix , form);
        addressSummaryFormGroup.removeClass('in');
        addressSummary.find('.address-line-street').text(obj.house + ' ' + obj.street + ', ');
        addressSummary.find('.address-line-city').text(obj.town + ', ');
        if (address2.val() != '') {
            addressSummary.find('.address-line-locality').text(obj.area + ', ').show();
        } else {
            addressSummary.find('.address-line-locality').text('').hide();
        }
        addressSummary.find('.address-line-county').text(obj.county + ', ');
        addressSummary.find('.address-line-postcode').text(obj.postcode);
        postCodeFormGroup.addClass('hidden');
        address2FormGroup.addClass('hidden');
        addressSummaryFormGroup.removeClass('hidden').addClass('in');
    } else {
        var addressFields = $('.address-fields', form);
        var address2 = $('[name=address2]', form);
        var address2FormGroup = $('.address2-form-group', form);
        addressFields.removeClass('hidden');
        setTimeout(function () {
            addressFields.addClass('in');
        }, 200);
        if (address2.val() != '') {
            address2FormGroup.removeClass('hidden');
        } else {
            address2FormGroup.addClass('hidden');
        }
    }
}

export function formatCurrency(x) {
    return ((x === '' || x === null) ? '' : '£') + x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function unformatCurrency(x) {
    var y = x.replace(/,/g, '');
    var q = y.replace(/,/, '');
    var z = q.replace(/£/, '');
    return z;
}

export function otfValidate(field) {
    resetFormField(field);
    var data = {};
    var fieldVal = field.val();
    data[field.attr('name')] = fieldVal;
    var form = field.closest('form');
    var formType = form.attr('action');
    if (field.is('[name=following_pay_date]')) {
        data.next_pay_date = field.closest('form').find('[name=next_pay_date]').val();
    }
    field.removeClass('otf-pass otf-fail');
    $.ajax({
        type: "POST",
        data: data,
        url: "/validate"
    })
    .done(function(data) {
        var valid = data.valid;
        if (valid === true) {
            field.addClass('otf-pass');
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'form',
                'question': field.attr('name'),
                'validation': 'valid'
            });
            window.amplitude.formInteractionEvent(field.attr('name'), 'valid', '', formType);
            if (field.attr('name') === 'dob') {
                $('.dob-single').removeClass('otf-fail').addClass('otf-pass');
            }
            if (field.is('[name=next_pay_date]')) {
                form.find('[name=next_pay_date_mobile]').addClass('otf-pass');
            }
            if (field.is('[name=following_pay_date]')) {
                form.find('[name=following_pay_date_mobile]').addClass('otf-pass');
            }
        } else {
            displayErrorMessages(data.messages, form, false);
            field.addClass('otf-fail');
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'form',
                'question': field.attr('name'),
                'validation': 'invalid'
            });
            window.amplitude.formInteractionEvent(field.attr('name'), 'invalid', data.messages[field.attr('name')], formType);
            if (field.attr('name') === 'dob') {
                $('.dob-single').removeClass('otf-pass').addClass('otf-fail');
            }
        }
        field.trigger('validated.digiloans', { valid: valid });
    })
    .fail(function(jqXHR, textStatus, errorThrown) {
        field.trigger('validated.digiloans', { valid: null });
    });    
}

export function sendForm($formName) {
    var form = $($formName);
    getExtrasInput(form);
    if (!form.is('form')) {
        form = form.closest('form');
    }

    var cashWithdrawal = $("[name=cash_advance]").val();
    if (typeof cashWithdrawal !== 'undefined') {
        window.amplitude.productDetailsEvent(cashWithdrawal);
    }

    sendSentryBreadcrumb({
        message: 'Sending form',
        category: 'action',
        data: {
            journey: window.journey,
            thisPage: form.find('[name=thisPage]').val(),
            nextPage: form.find('[name=nextPage]').val()
        }
    });
    var formData = form.serialize();
    var formType = form.attr('action');
    $.ajax({
        type: "POST",
        data: formData,
        url: "/apply"
    })
    .done(function(data) {
        $('.next-btn.loading').removeClass('loading');
        var errorCount = data.errorCount;
        var nextPage = data.nextPage;
        var digid = data.digid;
        var score = data.score;
        var estatus = data.estatus;
        var pingtree = $('#pingtree').val();
        $('.fname-text').text(form.find('[name=forename]').val());
        if (errorCount > 0) {
            document.nextButtonClicked = false;
            sendSentryBreadcrumb({
                message: 'Sending form',
                category: 'action',
                data: {
                    journey: window.journey,
                    thisPage: form.find('[name=thisPage]').val(),
                    nextPage: form.find('[name=nextPage]').val(),
                    errors: data
                }
            });
            displayErrorMessages(data, form, true);
            window.amplitude.formSubmissionEvent(formType, 'submit error', window.journey);
            if ($("label[for='house']").hasClass('form-error') && $("#addressSelect").is(':visible')) {
                $("label[for='addressSelect']").addClass('form-error');
            }
            goToError(form);
        } else if (data.status === 'interest_registered') {
            location.href = '/interest-registered';
        } else if (nextPage) {
            document.nextButtonClicked = false;
            var formWrapper = $('#form-wrapper');
            formWrapper.css('min-height', formWrapper.height());
            form.find('.form-page').velocity('transition.fadeOut');
            var nextForm = $('.' + nextPage).closest('form');
            nextPage = $('.' + nextPage);
            $('.digid').val(digid);
            var containers = nextPage.find('.container');
            containers.css('opacity', 0);
            nextPage.show();
            setRating(score, estatus, cs);
        } else {
            var email = '';
            try {
                email = String(form.find('[name=email]').val() || '').toLowerCase().trim();
            } catch (e) {}
            let age = calculateAge(parseDate(form.find('[name=dob]').val()), new Date());
            let postCode = String(form.find('[name=postcode]').val() || '').toLowerCase().trim().substring(0, 3);
            let otherOutgoings = String(form.find('[name=expenditure]').val() || '');
            let monthlyRentMortgage = String(form.find('[name=housing]').val() || '');
            let monthlyIncome = String(form.find('[name=income]').val() || '');
            let cardType = String(form.find('[name=card_type]').val() || '');
            window.amplitude.applyUserProperties({
                'user_age': age,
                'property_postcode': postCode,
                'finances_other_outgoings': otherOutgoings,
                'finances_monthly_rent_mortgage': monthlyRentMortgage,
                'finances_monthly_income': monthlyIncome
            });
            window.amplitude.formSubmissionEvent(formType, 'applied', window.journey);
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'app',
                'appStatus': 'applied',
                'journey': window.journey,
                'email': email,
                'card_type': cardType
            });
            ajaxDirector(digid);
        }
    })
    .fail(function(jqXHR, textStatus, errorThrown) {
        document.nextButtonClicked = false;
        $('.next-btn.loading').removeClass('loading');
    });
}

export function goToError(form) {
    if ($('.form-group.error', form).length > 0) { // Scroll to first element with an error, if there is one, and focus on the field
        $('.form-group.error', form).each(function() {
            $(this).closest('div.accordion-on').find('.form-group, .accordion-button-wrapper').show();
        });
        var error = $(".form-group.error", form);
        if (!error.is(':visible')) {
            error.removeClass('hidden hide fade in').show();
            try {
                var errorString = error.find('input,select').first().prop('name') + ' was hidden and needed to display an error';
                throw errorString;
            } catch (e) {
                if (typeof Raven !== 'undefined') {
                    Raven.captureException(e);
                }
            }
        }
        error.first().velocity("scroll", {
            easing: "easeOutQuad",
            offset: -70,
            duration: 500,
            delay: 100
        });
        $('.form-group.error', form).first().find('.form-field input, .form-field select').first().focus();
    }
}

window.sendApplicationTimeout = 1000 * 60 * 5; // 5 minutes
window.sendApplicationStart = null;
window.sendApplicationMaxNumberOfRetries = 3;

export function defaultRedirect(id, appStatus) {
    if (window.sendApplicationMaxNumberOfRetries > 0) {
        window.sendApplicationStart = null;
        window.sendApplicationMaxNumberOfRetries--;
        ajaxDirector(id, appStatus);
    } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'app',
            'appStatus': 'declined'
        });
        // Get the default exit offer
        var url = '/decline/' + id;
        top.location = url;
    }
}

export function showLoadingPage() {
    $('#loans-main-header').hide();
    $('.form-sections-col').hide();
    $('.return-customer-section').hide();
    $('.header-form-container').hide();
    $('.form-sections-wrapper').hide();
    $('.form-faqs').hide();
    $('.exit-searching').show();
    $('.approval-time-box-container .end-paragraph .loading').show();
    startLoadingBar();
}
export function showPreApprovedPage() {
    $('#loans-main-header').hide();
    $('.form-sections-col').hide();
    $('.return-customer-section').hide();
    $('.header-form-container').hide();
    $('.form-sections-wrapper').hide();
    $('.exit-searching').hide();
    $('#loans-sticky-header').hide();
    $('.pre-approval').show();
    $('.approval-time-box-container .end-paragraph .loading').show();
    startLoadingBar();
}

export function resubmitCust(digid) {
    $.ajax({
        type: 'POST',
        dataType: 'json',
        data: { id: digid },
        url: "/save-resubmit-application"
    })
    .done(function(data) {
        ajaxDirector(data.digid);
    })
    .fail(function(jqXHR, textStatus, errorThrown) {
        // document.nextButtonClicked = false;
        // $('.next-btn.loading').removeClass('loading');
    });
}

export function backButtonCust() {
    window.journey = '5';
    ajaxDirector();
}

export function ajaxDirector(digid, appStatus = 'zable'){
    /*
     * Card journey
     * appStatus =  zable  - the next action is to send the customer to benson then the customer application to zable for a decision.
     * appStatus =  creditec - the customer application has been declined by zable or an error with zable has occured. The next action is to send the customer application to creditec.
     * appStatus =  npl      - the customer has been declined by creditec or an error with creditec has occured. The next action is to send the customer to NPL / loans.
     * Loans journey
     * appStatus =  creditecLoans  - if declined by zable the customer will be sent to creditec loans.
     */
    digid = typeof digid !== 'undefined' ? digid : null;
    var pingtree = typeof pingtree !== 'undefined' ? pingtree : null;
    var remarketing = typeof remarketing !== 'undefined' ? remarketing : null;
    var url = '/send-application-credit';
    //journey 2 is loans downsell &  journey 5 is loans downsell back button
    if (window.journey == '2' || window.journey == '5') {
        url = '/send-application';
        appStatus = 'npl';
    }
    if (appStatus === 'zable') {
        return sendApplicationZable(digid, url, appStatus);
    }
    if (appStatus === 'creditec') {
        return sendApplicationCreditec(digid, url, appStatus);
    }
    if (appStatus === 'creditecLoans') {
        return sendApplicationCreditecLoans(digid, url, appStatus);
    }
    if (appStatus === 'npl') {
        return sendApplicationNPL(digid, appStatus);
    }
}

/*  front-end function responsible for handling the zable request
    this function is only called at the start of the application process and when the parameters passed are: appStatus = zable
    once the function completes it updates the above flags accordingly and then calls the ajaxDirector so the application proccess can continue.
*/
export function sendApplicationZable(digid, url, appStatus) {
    document.sendApplicationStart = new Date();
    var page1 = $('.form-eligibility-loader-page-1');
    var page2 = $('.form-eligibility-loader-page-2');
    var page3 = $('.form-eligibility-loader-page-3');
    url = url + '/' + appStatus;
    $.ajax({
        type: 'POST',
        timeout: 95000,
        url: url,
        dataType: 'json',
        data: { id: digid },
        beforeSend: function() {
            if (window.journey === '1' || window.journey === '3') {
                openCreditApplicationLoader();
            } else if (window.journey === '4') {
                // Do nothing
            } else {
                showLoadingPage();
                $(".page").first().velocity("scroll", {
                    easing: "easeOutQuad",
                    offset: -320,
                    duration: 500,
                    delay: 100
                });
            }
        }
    })
    .done(function(data) {
        document.nextButtonClicked = false;
        if (data.type === 'vulnerableCustomer') {
            setTimeout(function() {
                location.href = data.data.redirect_url;
            }, 3000);
        }
        if (data.type === 'thimbl') {
            // Check returned value of 'accepted'
            if (data.data.accepted === true) {
                if (window.journey === '4') {
                    setTimeout(function() {
                        location.href = data.data.redirect_url;
                    }, 3000);
                }
                // Send amplitude response event
                window.amplitude.formApplicationResponse({
                    event: 'creditCardConversion',
                    commission: data.data.commission || 0,
                    decision: data.data.zableState,
                    product: 'Thimbl',
                    apr: data.data.apr,
                    eligibility: data.data.eligibility,
                });
                // Send the creditCardConversion to the dataLayer with commission and brokered final decision
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'creditCardConversion',
                    commission: data.data.commission || 0,
                    decision: data.data.zableState,
                    product: 'Thimbl',
                    apr: data.data.apr,
                    eligibility: data.data.eligibility,
                });
                // Set appStatus = complete = zable accepted, accepted downsell or referred the customer application, customer journey complete
                appStatus = 'complete';
                page1.velocity("fadeOut", {
                    delay: 0,
                    duration: 300,
                    complete: function() {
                        if (data.data.zableState === 'quoted' && data.data.eligibility === 100) {
                            page2.delay(0).queue(function(next) {
                                $(this).addClass('table-cell');
                                next();
                            });
                            $('.form-eligibility-loader-page-2-inner-container').velocity("transition.slideUpIn", {
                                delay: 0,
                                duration: 1000,
                                complete: function() {
                                    setTimeout(function() {
                                        location.href = data.data.redirect_url;
                                    }, 3000);
                                }
                            });
                        }

                        if (data.data.zableState === 'quoted' && data.data.eligibility < 100) {
                            page3.delay(0).queue(function(next) {
                                $(this).addClass('table-cell');
                                next();
                            });
                            $('.form-eligibility-loader-page-3-inner-container').velocity("transition.slideUpIn", {
                                delay: 0,
                                duration: 1000,
                                complete: function() {
                                    setTimeout(function() {
                                        location.href = data.data.redirect_url;
                                    }, 3000);
                                }
                            });
                        }
                    }
                });
            } else {
                // Send amplitude response event
                window.amplitude.formApplicationResponse({
                    event: 'creditCardConversion',
                    commission: data.data.commission || 0,
                    decision: data.data.zableState,
                    product: 'Thimbl',
                    apr: data.data.apr,
                    eligibility: data.data.eligibility,
                });
                // Set the appStatus = creditec = zable declined or there was an error send onwards to creditec
                appStatus = 'creditec';
            }
            ajaxDirector(digid, appStatus);
        }
    })
    .fail(function(jqXHR, textStatus, errorThrown) {
        document.nextButtonClicked = false;
        appStatus = 'creditec';
        ajaxDirector(digid, appStatus);
    });
}

/*  front-end function responsible for handling the creditec request
    this function is only called once zable has made a decision on the customer application and when the parameters passed are: appStatus = creditec.
    once the function completes it updates the appStatus accordingly and then calls the ajaxDirector so the application proccess can continue.
*/
export function sendApplicationCreditec(digid, url, appStatus){
    var page1 = $('.form-eligibility-loader-page-1');
    var shape1 = $('.shape-top-right');
    var shape2 = $('.shape-bottom-left');
    document.sendApplicationStart = new Date();
    url = url + '/' + appStatus;
    $.ajax({
        type: 'POST',
        timeout: 95000,
        url: url,
        dataType: 'json',
        data: { id: digid }
    })
    .done(function(data) {
        document.nextButtonClicked = false;
        if (data.type === 'ccc' && (!data.data.cccId || data.data.accepted === false)) {
            // Send Creditec decline event to Amplitude
            window.amplitude.formApplicationResponse({
                event: 'creditecDecline',
                product: 'Creditec',
            });
            appStatus = 'npl';
            sendApplicationNPL(digid, appStatus);
            return;
        }
        if (data.type === 'ccc' && data.data.cccId) {
            if (window.journey === '4') {
                setTimeout(function() {
                    location.href = '/apply/loan/' + digid + '?offers=' + data.data.cccId;
                }, 3000);
                return;
            } else if (data.data.accepted === true) {
                // Send the customer to the loans form and show CCC overlay
                page1.velocity("fadeOut", {
                    delay: 0,
                    duration: 1000,
                    complete: function() {
                        shape1.css('display', 'none');
                        shape2.css('display', 'none');
                        // Send Creditec accept event to Amplitude
                        window.amplitude.formApplicationResponse({
                            event: 'creditecAccept',
                            product: 'Creditec',
                        });
                        // Send Creditec accept event to dataLayer
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            event: 'creditecAccept'
                        });
                        setTimeout(function() {
                            location.href = '/apply/loan/' + digid + '?offers=' + data.data.cccId;
                        }, 3000);
                    }
                });
                return;
            }
        }
        // Sentry
        sendSentryMessage("This should be unreachable - added to test if there is an issue here");
    })
    .fail(function(jqXHR, textStatus, errorThrown) {
        Sentry.captureException(errorThrown);
        document.nextButtonClicked = false;
        appStatus = 'npl';
        sendApplicationNPL(digid, appStatus);
    });
}

/*  front-end function responsible for handling the creditec loans request
*    this function is only called once zable has made a decision on the customer application and when the parameters passed are: appStatus = creditecLoans.
*    once the function completes it updates the appStatus accordingly and then calls the ajaxDirector so the application proccess can continue.
*/
export function sendApplicationCreditecLoans(digid, url, appStatus){
    document.sendApplicationStart = new Date();
    url = url + '/' + appStatus;
    $.ajax({
        type: 'POST',
        timeout: 95000,
        url: url,
        dataType: 'json',
        data: { id: digid }
    })
    .done(function(data) {
        document.nextButtonClicked = false;
        // Send Creditec accept event to dataLayer
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'creditecLoansAccept' });
        setTimeout(function() {
            location.href = data.data.cccId;
        }, 3000);
    })
    .fail(function(jqXHR, textStatus, errorThrown) {
        sendSentryMessage('Creditec Response Error', jqXHR, textStatus, errorThrown);
        location.href = '/loans';
    });
}

/*  front-end function responsible for handling the NPL / loans request
    this function is only called once zable and creditec has made a decision on the customer application or theres an error in the process flow and only when the parameters passed are: appStatus = npl.
*/
export function sendApplicationNPL(digid, appStatus){
    // console.log('NPL digid = ' . digid);
    // console.log('NPL appStatus = ' . appStatus);
    var page1 = $('.form-eligibility-loader-page-1');
    var shape1 = $('.shape-top-right');
    var shape2 = $('.shape-bottom-left');
    var url = '/send-application-credit/npl';
    document.sendApplicationStart = new Date();
    if (window.journey == '2' || window.journey == '5') {
        url = '/send-application';
    }

    // console.log('NPL URL = ' . url);
    $.ajax({
        type: 'POST',
        timeout: 95000,
        url: url,
        dataType: 'json',
        data: { id: digid },
        beforeSend: function() {
            if (window.journey === '2' || window.journey === '5') {
                showLoadingPage();
                $(".page").first().velocity("scroll", {
                    easing: "easeOutQuad",
                    offset: -320,
                    duration: 500,
                    delay: 100
                });
            }
        }
    })
    .done(function(data) {
        document.nextButtonClicked = false;
        if (window.journey === '2' || window.journey === '5') {
            setTimeout(function() {
                checkApplicationState(data.id);
            }, 5000);
        }
        if (window.journey === '4' && data.type === 'npl') {
            setTimeout(function() {
                location.href = '/apply/loan/' + digid + '?adf=' + data.data.active_debt_flag;
            }, 3000);
        }
        if (data.type === 'npl' && window.journey !== '2' && window.journey !== '4') {
            // Send the customer to the loans form
            page1.velocity("fadeOut", {
                delay: 0,
                duration: 1000,
                complete: function() {
                    shape1.css('display', 'none');
                    shape2.css('display', 'none');
                    setTimeout(function() {
                        location.href = '/apply/loan/' + digid + '?adf=' + data.data.active_debt_flag;
                    }, 3000);
                }
            });
        }
    })
    .fail(function(jqXHR, textStatus, errorThrown) {
        document.nextButtonClicked = false;
        if (window.journey === '1') {
            shape1.css('display', 'none');
            shape2.css('display', 'none');
            setTimeout(function() {
                location.href = '/apply/loan/' + digid + '?adf=' + data.data.active_debt_flag;
            }, 3000);
        }
        if (window.journey === '2' || window.journey === '5') {
            defaultRedirect(digid, appStatus);
        }
        if (window.journey !== '1' && window.journey !== '2') {
            setTimeout(function() {
                location.href = '/apply/loan/' + digid + '?adf=' + data.data.active_debt_flag;
            }, 3000);
        }
    });
}

export function doCustomSignpostCheck(url) {
    const urlActions = [
        { regex: /moneywellness/, action: moneywellnessSpinnerTransform },
        { regex: /phonexa/, action: () => customLenderSpinnerTransform('Loans 2 Go') },
    ];

    let actionFound = false;

    for (const { regex, action } of urlActions) {
        if (regex.test(url)) {
            action();
            actionFound = true;
            break;
        }
    }

    if (!actionFound) {
        finishLoadingBar();
    }
}

export function customLenderSpinnerTransform(lender) {
    document.getElementById('default-spinner-header').classList.add('hidden');
    document.getElementById('default-spinner-text').classList.add('hidden');
    document.getElementById('default-spinner-footer').classList.add('hidden');
    document.getElementById('progress-bar-circle').classList.add('complete', 'tick');
    document.getElementById('custom-lender-name').innerHTML = lender;
    document.getElementById('lender-spinner-text').classList.remove('hidden');
}

export function moneywellnessSpinnerTransform() {
    document.getElementById('default-spinner-header').classList.add('hidden');
    document.getElementById('default-spinner-text').classList.add('hidden');
    document.getElementById('default-spinner-footer').classList.add('hidden');
    document.getElementById('progress-bar-circle').classList.add('complete', 'tick');
    document.getElementById('mwg-spinner-text').classList.remove('hidden');
}

export function checkApplicationState(id, appStatus) {
    var now = (new Date()).getTime();
    var url = '/check-application';
    if (document.sendApplicationStart != null && now - document.sendApplicationStart > document.sendApplicationTimeout) {
        // Timeout, ask for the default app
        defaultRedirect(id, appStatus);
    } else {
        $.ajax({
            url: url,
            method: 'POST',
            data: { id: id },
            dataType: 'json'
        })
        .done(function(data) {
            if (data.status === 'processing' || data.status === 'Processing') {
                setTimeout(function() {
                    checkApplicationState(id, appStatus);
                }, 5000);
            } else if (data.status === 'complete' && typeof data.url !== 'undefined') {
                // Get the URL and redirect
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'loanConversion',
                    commission: data.commission
                });
                redirect(data.url, id);
            } else if (data.status === 'complete' && data.accepted === false) {
                defaultRedirect(id, appStatus);
            } else if (data.status === 'error' && (data.description === 'no results' || data.description === 'not in panel')) {
                defaultRedirect(id, appStatus);
            }
        })
        .fail(function() {
            setTimeout(function() {
                checkApplicationState(id, appStatus);
            }, 5000);
        });
    }
}

export function redirect(url, id) {
    window.delCookie(window.cookieName);
    setTimeout(function() {
        if (!getCookie("th_rc")) {
            setCookie("th_rc", id, 600);

        } else {
            setCookie("th_rc", id, -6000);
        }
        location.href = url;
    }, 4000);
    doCustomSignpostCheck(url);
}

export function getPostcode(context, suffix) {
    if (typeof suffix == 'undefined') {
        suffix = '';
    }
    if (document.postCodeSearchTimeout != null) {
        clearTimeout(document.postCodeSearchTimeout);
    }
    var postcodeFunction = function() {
        context = context || $(document);
        var postCode = $('[name=postcode' + suffix + ']', context).val();
        if (postCode == '')
            return false;
        if ($(".find-address" + suffix).hasClass('clicked'))
            return false;
        $('#addressSelect' + suffix).find('option').remove();
        $.ajax({
            type: "POST",
            dataType: "json",
            url: '/postcode/' + postCode.replace(/ /g, ''),
            beforeSend: function() {
                context.find(".find-address" + suffix).addClass('loading');
            },
            timeout: 5000
        })
        .done(function(result) {
            context.find(".find-address" + suffix).removeClass('loading');
            if (result.length > 0) {
                context.find('.find-address' + suffix).addClass('hidden');
            }
            var selectValues = result;
            var addressSelect = context.find('[name=addressSelect' + suffix + ']').first().removeClass('hidden');
            addressSelect.find('option').remove();
            addressSelect.append($('<option>', { selected: 'selected' }).text('Select Address'));
            $.each(selectValues, function(key, value) {
                addressSelect.append($('<option>', {
                    value: JSON.stringify({
                        house: value.house,
                        street: value.line1,
                        area: value.locality,
                        town: value.city,
                        county: value.county,
                        postcode: postCode.toUpperCase()
                    })
                }).text(value.full));
            });
            addressSelect.closest('.form-group').removeClass('hidden');
            addressSelect.slideDown(500);
            addressSelect.focus();
        
            var selSize = addressSelect.find('option').length;
            if (selSize > 20) {
                selSize = 10;
            }
            addressSelect.attr('size', selSize);
            addressSelect.trigger('mousedown');
            clearTimeout(document.postCodeSearchTimeout);
        })
        .fail(function() {
            $("#address_lookup" + suffix, context).val(1);
            $('.address-fields' + suffix, context).slideDown(500).removeClass('hidden').addClass('in');
            $(".find-address" + suffix, context).removeClass('loading');
            $(".form-group.addressSelect" + suffix, context).addClass('hidden');
            $(".invalid-address" + suffix, context).show();
            $(".invalid-address" + suffix, context).first().velocity("scroll", {
                easing: "easeOutQuad",
                offset: -320,
                duration: 500,
                delay: 100
            });
            $('[name=house' + suffix + ']', context).focus();
            clearTimeout(document.postCodeSearchTimeout);
        });
    };
    setTimeout(postcodeFunction, 300);
}

export function showAddressFields(suffix) {
    var suffix = suffix;
    if (typeof suffix == 'undefined') {
        suffix = '';
    } else {
        suffix = '_'+suffix;
    }
    $('.address-fields'+ suffix).slideDown('500');
    $('.address-fields'+ suffix).removeClass('otf-pass').removeClass('hidden').addClass('in');
    $('.invalidAddress').hide();
    $('.address-manual').hide();
    $('.postcode'+ suffix +'-form-group').removeClass('hidden').addClass('in'); 
    $('.address_summary'+ suffix +'-form-group').addClass('hidden');
    $('.find-address').addClass('hidden');
    document.doNotUsePostcodeLookup = true;
}

export function resetAddressFields(suffix) {
    if (typeof suffix == 'undefined') {
        suffix = '';
    } else {
        suffix = '_'+suffix;
    }

    var addressSummaryFormGroup = $('.address_summary' + suffix +'-form-group');
    var postCodeFormGroup = $('.postcode' + suffix +'-form-group');
    var addressFields = $('.address-fields'  + suffix);
    var findAddressBtn = $('.find-address' + suffix);
    var postcodeField = $('[name=postcode' + suffix +']');

    addressFields.find(':input').removeClass('otf-pass').removeClass('hidden').val('');
    postCodeFormGroup.css('display', 'block');
    postCodeFormGroup.removeClass('hidden').addClass('in');
    postcodeField.val('').removeClass('otf-pass').focus();
    findAddressBtn.removeClass('hidden').removeClass('in');
    $('.address-research').addClass('hidden');
    document.doNotUsePostcodeLookup = false;
    document.addressSelected = false;
    $('.invalidAddress').hide();
    $('.address-manual').show();
    if ($('body').is('.with-address-summary')) {
        addressSummaryFormGroup.addClass('hidden').removeClass('in');
        postCodeFormGroup.removeClass('hidden');
    }
}

export function lockButton(term) {
    el = $(".term-button[data-value='" + term + "']");
    $(el).addClass('term-btn-locked');
    $(el).html("N/A");
    //$(el).find('p').addClass('locked-text');
}

export function unlockButton(term) {
    el = $(".term-button[data-value='" + term + "']");
    $(el).removeClass('term-btn-locked');
    $(el).html(term);
}

export function resetMonthlyOutgoingInputs() {
    var input1 = $("[name=income]");
    var input2 = $("[name=expenditure]");
    if (input1.val() === '') {
        input1.val(0);
    }
    if (input2.val() === '') {
        input2.val(0);
    }
}

export function resetFormField(element) {
    element.removeClass('otf-fail field-error otf-pass');
    element.closest('.form-group').removeClass('error');
}

// export function prefillCs(cs, context) {
//     context = context || $(document);
//     var title = $('[data-value=' + cs.title + ']', context);
//     title.click();
//     var forename = $('[name=forename]', context);
//     forename.closest('.form-field').find('input').addClass('otf-pass').val(cs.forename);
//     forename.val(cs.forename).blur();
//     var surname = $('[name=surname]', context);
//     surname.closest('.form-field').find('input').addClass('otf-pass').val(cs.surname);
//     surname.val(cs.surname).blur();
//     var email = $('[name=email]', context);
//     if (window.journey != 5) {
//         email.closest('.form-field').find('input').addClass('otf-pass').val(cs.email);
//     }
//     email.val(cs.email).blur();
//     var dob = $('[name=dob]', context);
//     dob.closest('.form-field').find('input').addClass('otf-pass').val(cs.dob);
//     dob.val(cs.dob).blur();
//     var income = $('[name=income]', context);
//     income.closest('.form-field').find('input').addClass('otf-pass').val(cs.dob);
//     income.val(cs.income).blur();
//     var house = $('[name=house]', context);
//     if (window.journey != 5) {
//         house.closest('.form-field').find('input').addClass('otf-pass').val(cs.house);
//     }
//     house.val(cs.house).blur();
//     var address1 = $('[name=address1]', context);
//     if (window.journey != 5) {
//         address1.closest('.form-field').find('input').addClass('otf-pass').val(cs.address1);
//     }
//     address1.val(cs.address1).blur();
//     var address2 = $('[name=address2]', context);
//     if (window.journey != 5) {
//         address2.closest('.form-field').find('input').addClass('otf-pass').val(cs.address2);
//     }
//     address2.val(cs.address2).blur();
//     var town = $('[name=town]', context);
//     if (window.journey != 5) {
//         town.closest('.form-field').find('input').addClass('otf-pass').val(cs.town);
//     }
//     town.val(cs.town).blur();
//     var county = $('[name=county]', context);
//     if (window.journey != 5) {
//         county.closest('.form-field').find('select').addClass('otf-pass').val(cs.county);
//     }
//     county.val(cs.county).blur();
//     var postcode = $('[name=postcode]', context);
//     if (window.journey != 5) {
//         postcode.closest('.form-field').find('input').addClass('otf-pass').val(cs.postcode);
//     }
//     postcode.val(cs.postcode).blur();
//     var address = [];
//     if (house.val() != '') {
//         address.push(house.val());
//     }
//     if (address1.val() != '') {
//         address.push(address1.val());
//     }
//     if (address2.val() != '') {
//         address.push(address2.val());
//     }
//     if (town.val() != '') {
//         address.push(town.val());
//     }
//     if (county.val() != '') {
//         address.push(county.val());
//     }
//     if (postcode.val() != '') {
//         address.push(postcode.val());
//     }
//     $('.address-fields').not('.invalidAddress').removeClass('fade hidden');
//     if ($('[name=address2]', context).val() != '') {
//         $('.address2-form-group', context).removeClass('hidden');
//     } else {
//         $('.address2-form-group', context).addClass('hidden');
//     }
//     if (window.journey == 5) {
//         $('.address-fields').not('.invalidAddress').addClass('fade hidden');
//     }
// }

// export function prefillLn(ln, context) {
//     context = context || $(document);
//     $('[data-update-field=employment_status][data-value=' + ln.home_status + ']', context).click();
//     $('[data-update-field=time_at_address][data-value=' + ln.time_at_address + ']', context).click();
//     var employment_status = $('[data-value=' + ln.employment_status + ']', context).click();
//     employment_status.closest('.form-field').find('.form-field-display .value').text(employment_status.text());
//     $('[name=income]', context).val(ln.income).blur();
//     $('[name=income]').closest('.form-field').find('.form-field-display .value').text('£' + ln.income);
//     var home_status = $('[data-value=' + ln.home_status + ']', context.find('input[name=home_status]').closest('.form-group'));
//     home_status.closest('.form-field').find('.form-field-display .value').text(home_status.text());
//     home_status.click();
//     var time_at_address = $('[data-value=' + ln.time_at_address + ']', context.find('input[name=time_at_address]').closest('.form-group'));
//     time_at_address.closest('.form-field').find('.form-field-display .value').text(time_at_address.text());
//     time_at_address.click();
// }
// Takes date in dd/mm/yyyy format
export function isValidDate(s) {
    var bits = s.split('/');
    var d = new Date(bits[2], bits[1] - 1, bits[0]);
    return d && (d.getMonth() + 1) == bits[1];
}

export function displayErrorMessages(messages, form, submit) {
    var formType = form.attr('action');
    $.each(messages, function(key, value) {
        var firstValue = value.toString().split(',')[0];
        var element = $('[name=' + key + ']', form);
        var formGroup = element.closest('.form-group');
        formGroup.addClass('error');
        formGroup.find(".form-label label[for='" + key + "'].form-error").html(firstValue + '*');
        if (element.is('.otf-val') || (element.is('[name=postcode]') && element.val() == '')) {
            element.addClass('otf-fail');
        }
        if (element.is('[name=dob1]') || element.is('[name=dob2]') || element.is('[name=dob3]')) {
            formGroup.find(".form-label label[for='dob'].form-error").html('Date of birth invalid*');
        }
        if (key === 'termsconditions') {
            $(".checkbox-container").addClass('field-error');
        }
        if (submit === true) {
            window.amplitude.formInteractionEvent(key, 'error', '', formType);
            // window.dataLayer = window.dataLayer || [];
            // window.dataLayer.push({
            //     'event': 'form',
            //     'question': key,
            //     'validation': 'submit error'
            // });
        }
    });
}

export function startLoadingBar() {
    var timings = {
        100: 7000,
        90: 6800,
        80: 6300,
        70: 5000,
        51: 4000,
        46: 2000,
        40: 1000,
        30: 500,
        20: 200,
        0: 200
    };
    var getTiming = function(iterator) {
        for (var k in timings) {
            k = parseInt(k, 10);
            if (timings.hasOwnProperty(k) && iterator < k) {
                return timings[k];
            }
        }
    };
    // Start the loop
    var progressBarCircle = $('#progress-bar-circle').first();
    if (progressBarCircle.length === 1) {
        var text = progressBarCircle.find('.text');
        var i = 0;
        var timeoutLoop = function() {
            if (i >= 100) {
                return false;
            }
            i++;
            var timing = getTiming(i);
            text.html((i < 10 ? '&nbsp;' : '') + i + '<small>%</small>');
            setTimeout(timeoutLoop, timing);
        };
        timeoutLoop();
    }
}

export function finishLoadingBar() {
    var container = $('#application_searching_container');
    container.find('#progress-bar-circle').addClass('complete');
    container.find('.end-paragraph').addClass('complete');
    container.find('h1, h2').addClass('complete');
}

// export function getPermissionPopoverText() {
//     return '<strong>Products and services</strong>' + '<ul>' +
//     '<li>Equity Release</li>' +
//     '<li>Secured Loans</li>' +
//     '<li>Guarantor Loans</li>' +
//     '<li>Debt Advice</li>' +
//     '<li>Current Accounts</li>' +
//     '<li>Claims Management Services</li>' +
//     '<li>Credit Cards</li>' +
//     '</ul>';
// }

export function setPayDates(date1, date2, form) {
    date1 = date1.toLocaleDateString('en-GB');
    date2 = date2.toLocaleDateString('en-GB');
    otfValidate($('[name=next_pay_date]', form).val(date1));
    otfValidate($('[name=following_pay_date]', form).val(date2));
    otfValidate($('[name=next_pay_date_mobile]', form).val(date1));
    otfValidate($('[name=following_pay_date_mobile]', form).val(date2));
}

export function clearPayDates(form) {
    resetFormField($('[name=next_pay_date]', form).val(''));
    resetFormField($('[name=following_pay_date]', form).val(''));
    resetFormField($('[name=next_pay_date_mobile]', form).val(''));
    resetFormField($('[name=following_pay_date_mobile]', form).val(''));
}
Date.prototype.addDays = function(days) {
    var dat = new Date(this.valueOf());
    dat.setDate(dat.getDate() + days);
    return dat;
};

export function getLastDayOfWeekForMonth(dayOfWeek, today) {
    today = today || new Date();
    var month = today.getMonth();
    var year = today.getFullYear();
    var t = new Date(year, month + 1, 0);
    while (t.getDay() != dayOfWeek) {
        t.setDate(t.getDate() - 1);
    }
    if (t <= today) {
        return getLastDayOfWeekForMonth(dayOfWeek, new Date(year, month + 1, 1));
    } else {
        return t;
    }
}

export function getLastWorkingDayForMonth(today) {
    today = today || new Date();
    var month = today.getMonth();
    var year = today.getFullYear();
    var t = new Date(year, month + 1, 0);
    while (t.getDay() == 0 || t.getDay() == 6) {
        t.setDate(t.getDate() - 1);
    }
    if (t <= today) {
        return getLastWorkingDayForMonth(new Date(year, month + 1, 1));
    } else {
        return t;
    }
}

export function getLast2DaysOfMonth(dayOfWeek) {
    var one = getLastDayOfWeekForMonth(dayOfWeek);
    var two = getLastDayOfWeekForMonth(dayOfWeek, new Date(one.getFullYear(), one.getMonth() + 1, 1));
    return [one, two];
}

export function getLast2WorkingDaysOfMonth() {
    var one = getLastWorkingDayForMonth();
    var two = getLastWorkingDayForMonth(new Date(one.getFullYear(), one.getMonth() + 1, 1));
    return [one, two];
}

export function payFrequencyChange(form) {
    var date1;
    var today = new Date();
    var dates;
    switch ($('[name=pay_frequency]', form).val()) {
        case 'last_working_day':
            dates = getLast2WorkingDaysOfMonth();
            setPayDates(dates[0], dates[1], form);
            break;
        case 'last_friday':
            dates = getLast2DaysOfMonth(5);
            setPayDates(dates[0], dates[1], form);
            break;
        case 'last_thursday':
            dates = getLast2DaysOfMonth(4);
            setPayDates(dates[0], dates[1], form);
            break;
        case 'last_wednesday':
            dates = getLast2DaysOfMonth(3);
            setPayDates(dates[0], dates[1], form);
            break;
        case 'last_tuesday':
            dates = getLast2DaysOfMonth(2);
            setPayDates(dates[0], dates[1], form);
            break;
        case 'last_monday':
            dates = getLast2DaysOfMonth(1);
            setPayDates(dates[0], dates[1], form);
            break;
        default:
            clearPayDates(form);
            break;
    }
}

var updateFormGroupClassForPayFrequency = function(pay_frequency, group) {
    if (group.length === 1) {
        group.removeClass('specific_day last_working_day last_monday last_tuesday last_wednesday last_thursday last_friday four_weekly twice_monthly bi_weekly').addClass(payfrequency == 'error' ? '' : payfrequency);
    }
};

export function updateNextPayDateFormGroupForPayFrequency(pay_frequency, form) {
    var group = form.find('.next_paydate-form-group');
    updateFormGroupClassForPayFrequency(pay_frequency, group);
};

export function updateFollowingPayDateFormGroupForPayFrequency(pay_frequency, form) {
    var group = form.find('.following_paydate-form-group');
    updateFormGroupClassForPayFrequency(pay_frequency, group);
};

export function withCommas(x) {
    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
}

export function openCreditApplicationLoader()
{
    $('.form-eligibility-loader').velocity('transition.fadeIn');
}
// checks if the given element is currently in the viewport and returns boolean representing the result
export function isInViewport(element) {
    if (!element) {
        return false;
    }
    const elementPosition = element.getBoundingClientRect();
    return (
        elementPosition.top  >= 0 &&
        elementPosition.left >= 0 &&
        elementPosition.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        elementPosition.right  <= (window.innerWidth  || document.documentElement.clientWidth)
    );
}
/* checks that the form fields inside of form section 1 have their values set, if an input field does not yet have a 
   value the for loop will break and the first none hidden field with no value will become the focused element */
 export function setPostAutofillFocus(){
    try{
        const formSection1InputFields = document.querySelectorAll('.form-section-1')[0].querySelectorAll('input');
        for (const field of formSection1InputFields){
            if (field.value === '' && field.type != 'hidden'){
                field.focus();
                break;
            }
        }
    }
    catch(e){
    }
}
// this function gets passed a dom element which is then set to focus
export function setInputFocus(fieldToFocus) {
    fieldToFocus.focus();
}
// this function gets passed a dom element and its focus is removed
export function removeInputFocus(fieldToRemoveFocus) {
    fieldToRemoveFocus.blur();
}
// this function checks if there are any fields that need toggling visible or hidden
export function hiddenElementToggleCheck(field, fieldValue) {
    var repaymentElem = document.getElementsByName('repayments')[0];
    var repaymentAmountElem = document.getElementsByName('repayments')[1];

    if (field == 'existing_loan' && fieldValue == 'true') {
        repaymentElem.style.display = "inherit";
    }
    if (field == 'existing_loan' && fieldValue == 'false') {
        repaymentElem.style.display = "none";
        repaymentAmountElem.value = 0;
        repaymentAmountElem.classList.remove("otf-pass");
    }
    return;
}
//is valid date format
export function calculateAge(dateOfBirth, dateToCalculate) {
    var calculateYear = dateToCalculate.getFullYear();
    var calculateMonth = dateToCalculate.getMonth();
    var calculateDay = dateToCalculate.getDate();

    var birthYear = dateOfBirth.getFullYear();
    var birthMonth = dateOfBirth.getMonth();
    var birthDay = dateOfBirth.getDate();

    var age = calculateYear - birthYear;
    var ageMonth = calculateMonth - birthMonth;
    var ageDay = calculateDay - birthDay;

    if (ageMonth < 0 || (ageMonth == 0 && ageDay < 0)) {
        age = parseInt(age) - 1;
    }
    return age;
}
//convert the date string in the format of dd/mm/yyyy into a JS date object
export function parseDate(dateStr) {
    var dateParts = dateStr.split("/");
    return new Date(dateParts[2], (dateParts[1] - 1), dateParts[0]);
}

export function isDate(txtDate) {
    var currVal = txtDate;
    if (currVal == '')
        return true;

    //Declare Regex
    var rxDatePattern = /^(\d{1,2})(\/|-)(\d{1,2})(\/|-)(\d{4})$/;
    var dtArray = currVal.match(rxDatePattern); // is format OK?

    if (dtArray == null)
        return false;

    //Checks for dd/mm/yyyy format.
    var dtDay = dtArray[1];
    var dtMonth = dtArray[3];
    var dtYear = dtArray[5];

    if (dtMonth < 1 || dtMonth > 12)
        return false;
    else if (dtDay < 1 || dtDay > 31)
        return false;
    else if ((dtMonth == 4 || dtMonth == 6 || dtMonth == 9 || dtMonth == 11) && dtDay == 31)
        return false;
    else if (dtMonth == 2) {
        var isleap = (dtYear % 4 == 0 && (dtYear % 100 != 0 || dtYear % 400 == 0));
        if (dtDay > 29 || (dtDay == 29 && !isleap))
            return false;
    }

    return true;
}